// src/routes/ProtectedRoute.js
import { Navigate, Outlet } from "react-router-dom";
import { useAppContext } from "../contexts/appContext";
import Forbidden from "../pages/Error/403/403";

const ProtectedRoute = ({ allowedRoles }) => {
    const { user, loadingUser } = useAppContext();


    if (loadingUser) {
        // Show a loading spinner or placeholder while checking auth status
        return <div>Loading...</div>;
    }

    if (!user) {
        // not logged in
        return <Navigate to="/login" replace />;
    }

    if (!allowedRoles.includes(user.role)) {
        // logged in but wrong role → show 403
        return <Forbidden />;
    }

    // ✅ user is allowed → render child routes
    return <Outlet />;
};

export default ProtectedRoute;
